import { isFeatureEnabled, useIsFeatureEnabled } from './featureFlags';
import { SBOM_POLICY } from '../../../shared/featureFlags/flagNames';

/**
 * Frontend helper function for checking if the user's org has the SBOM Policy feature enabled.
 */
export const isSBOMPolicyEnabled = () =>
  isFeatureEnabled(SBOM_POLICY);

/**
 * Frontend helper hook for checking if the user's org has the SBOM Policy feature enabled
 * and memoized the result across re-renders.
 */
export const useIsSBOMPolicyEnabled = () => useIsFeatureEnabled(SBOM_POLICY);
